// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basicInfoIdle__hint[data-v-2cf60804]{margin:0;text-align:center;font-size:var(--link-text-sm,13px);font-weight:var(--link-font-medium,500);color:var(--link-ink-secondary,#4a4541);line-height:1.55}", ""]);
// Exports
module.exports = exports;
